var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.52,13v-1c.92,0,1.8,0,2.68,0A1.1,1.1,0,0,0,5,11.6a12.23,12.23,0,0,0,.91-2A2.52,2.52,0,0,1,7.47,7.75c.21-.07.37-.37.49-.6.81-1.52,1.6-3.05,2.42-4.61l.78.38L9.71,5.76l1.14.67L12.7,3l.78.4c-1,1.82-1.91,3.61-2.83,5.4-.17.34-.16.76-.31,1.11-.25.59-.41,1.36-.87,1.7a6.25,6.25,0,0,1-2.66,1.15C5.09,13,3.33,13,1.52,13ZM5.94,12a4.32,4.32,0,0,0,3.17-1.19,1.33,1.33,0,0,0-.94-2.25A1.18,1.18,0,0,0,7,9.35C6.64,10.19,6.31,11,5.94,12Zm4.5-4.72L9.29,6.57,8.71,7.66l1.17.63Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.35,
    y: 2.55,
    width: 3.14,
    height: 0.84,
    rx: 0.28,
    transform: "translate(2.67 -5.12) rotate(27.17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArts);
export default __webpack_public_path__ + "static/media/arts.098e3479e21950e4c553daf25d3b3028.svg";
export { ForwardRef as ReactComponent };